import { Injectable } from '@angular/core';
import { HeaderInterceptorService } from 'src/app/interceptors/header-interceptor';
@Injectable()
export class CustomerContectService {
    constructor(private customAxios: HeaderInterceptorService) { }

    /**
     * @name getAllCustomerContactLogin
     * @returns CustomerContactLogin
     */
    getAllCustomerContactLogin() {
        return this.customAxios.get('CustomerContactLogin/GetAllCustomerContactLogin');
    }


    /**
     * @name deleteCustomerContactLogin
     * @param CustomerContactLoginId
     * @returns Delete CustomerContactLogin
     */
    deleteCustomerContactLogin(CustomerContactLoginId) {
        return this.customAxios.get('CustomerContactLogin/DeleteCustomerContactLogin?CustomerContactLoginId=' + CustomerContactLoginId);
    }


    /**
   * @name addCustomerContactLogin
   * @param payload 
   * @param customerContactLoginId 
   */
  addCustomerContactLogin(payload: any, customerContactLoginId: number) {
    if (customerContactLoginId) {
      return this.customAxios.post(`CustomerContactLogin/UpdateCustomerContactLogin`, payload);
    } else {
      return this.customAxios.post(`CustomerContactLogin/AddCustomerContactLogin`, payload);
    }
  }

  
    /**
     * @name GetCustomerContactLoginById
     * @param CustomerContactLoginId
     * @returns customer contact data by id
     */
    getCustomerContactLoginById(CustomerContactLoginId) {
        return this.customAxios.get('CustomerContactLogin/GetCustomerContactLoginById?id=' + CustomerContactLoginId);
    }


    /**
     * @name getCustomerBranchByCustomerId
     * @returns CustomerBranch
     */
    getCustomerBranchByCustomerId(customerId: number) {
        return this.customAxios.get('CustomerBranch/GetCustomerBranchByCustomerId?customerId=' + customerId);
    }
    
  
}